import React from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import mergeStyles from '../../util/mergeStyles';
import { luxColors } from '../../../theming/themes/legacy/colors';
import Iffy from '../../util/Iffy/Iffy';
const styles = StyleSheet.create({
    icon: {
        tintColor: luxColors.subtitle.quaternary,
        height: 23,
        width: 23,
    },
    optionWrapper: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        paddingHorizontal: 26,
        paddingVertical: 12,
        borderBottomWidth: 3,
        borderBottomColor: 'transparent',
    },
    optionText: {
        color: luxColors.subtitle.quaternary,
        fontSize: 15,
        fontWeight: 'bold',
    },
    optionTextMargin: {
        marginLeft: 8,
    },
    row: {
        flexDirection: 'row',
    },
    selectedOptionTextColor: {
        color: luxColors.tag.primary,
    },
    selectedOptionIconColor: {
        tintColor: luxColors.tag.primary,
    },
    selectedOption: {
        borderBottomColor: luxColors.thumbnailBorder.primary,
    },
});
const selectedOptionTextColor = {
    info: luxColors.tag.primary,
    primary: luxColors.thumbnailBorder.primary,
};
const Tabs = (props) => {
    const { onSelectTab, selectedTab, selectedTabVariant, tabs, style } = props;
    return (<View style={[style, styles.row]}>
      {tabs.map((option, idx) => {
        const isSelected = option.title === selectedTab;
        return (<Tab selectedTabVariant={selectedTabVariant} key={idx} isSelected={isSelected} option={option} onTabSelected={onSelectTab}/>);
    })}
    </View>);
};
function Tab(props) {
    const { isSelected, option, selectedTabVariant = 'info' } = props;
    function onTabSelected() {
        props.onTabSelected(props.option.title);
    }
    return (<TouchableOpacity style={[styles.optionWrapper, option.style, isSelected && styles.selectedOption]} onPress={onTabSelected} activeOpacity={1} testID={'DNATab'}>
      <Iffy is={option.iconImage}>
        <Image source={option.iconImage} style={mergeStyles(undefined, styles.icon, [styles.selectedOptionIconColor, isSelected])}/>
      </Iffy>
      <Text style={mergeStyles(undefined, styles.optionText, [styles.optionTextMargin, option.iconImage], [{ color: selectedOptionTextColor[selectedTabVariant] }, isSelected])}>
        {option.title}
      </Text>
    </TouchableOpacity>);
}
export default Tabs;
//# sourceMappingURL=Tabs.js.map